import { Injectable, Injector } from '@angular/core';
import { HttpDataService } from '../../../core/services/http-data.service';
import { ClientsActivationSettings, SettingsRange } from './clients-activation-settings';

@Injectable()
export class ClientsActivationWidgetService extends HttpDataService {
  constructor(protected injector: Injector) {
    super(injector, '/dashboard/settings/clients-activation');
  }

  getClientsActivationSettings(): Promise<ClientsActivationSettings> {
    return this.fetch(null);
  }

  updateClientsActivationSettings(activationRanges: SettingsRange[]): Promise<ClientsActivationSettings> {
    return this.putRequest(this.baseUrl, activationRanges, this.getRequestOptions());
  }
}
